import { Injectable } from '@angular/core';

export interface ILocationParams {
  prms: string
}

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  public decodeParams<T>(prms: any): T {
    return JSON.parse(atob(prms['prms']));
  }

  public encodeParams<T>(value: T): ILocationParams {

    const cleanValue = {};
    Object.keys(value).forEach(key => {
      if (value[key]) {
        cleanValue[key] = value[key];
      }
    })

    return {
      prms: btoa(JSON.stringify(cleanValue))
    };
  }

}
